import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { formatDistanceToNow } from 'date-fns';

interface SyncStatusBadgeProps {
  status: string;
  lastSyncedAt?: string | null;
}

const statusConfig: Record<string, { label: string; className: string }> = {
  active: {
    label: 'Connected',
    className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  },
  success: {
    label: 'Synced',
    className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  },
  syncing: {
    label: 'Syncing',
    className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
  },
  error: {
    label: 'Error',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
  pending: {
    label: 'Pending',
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400',
  },
  revoked: {
    label: 'Revoked',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
  expired: {
    label: 'Expired',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
};

export function SyncStatusBadge({ status, lastSyncedAt }: SyncStatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig.pending;

  const title = lastSyncedAt
    ? `Last synced ${formatDistanceToNow(new Date(lastSyncedAt), { addSuffix: true })}`
    : 'Never synced';

  return (
    <Badge
      variant="outline"
      className={cn('border-none text-[11px] font-medium', config.className)}
      title={title}
    >
      {config.label}
    </Badge>
  );
}
